module.exports = __webpack_public_path__ + "static/media/daily-life-2023-4.0a30f544.webp";